import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

/**
 * SearchResultTable — design-system styled results table for the
 * Select-Ship-To-Party search (Firm Name / [GST-PAN] / Mobile Number / Role).
 *
 * @param {Array}   rows        the found companies to render
 * @param {Func}    onRowClick  called with the row when a row is clicked
 * @param {Boolean} showGstPan  show the GST / PAN column (hidden for Influencer)
 */
const SearchResultTable = ({
  rows = [],
  onRowClick = () => {},
  showGstPan = false,
}) => {
  const headerCellSx = {
    padding: { xs: 1, sm: 3 },
    borderBottom: "none",
  };
  const bodyCellSx = {
    padding: { xs: 1, sm: 2 },
    borderBottom: "none",
  };

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <Box sx={{ overflowY: "auto", height: "auto" }}>
      <TableContainer>
        <Table sx={{ width: "100%" }}>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#0D0D0D14",
                "& th:first-of-type": {
                  borderTopLeftRadius: { xs: "8px", sm: "16px" },
                },
                "& th:last-of-type": {
                  borderTopRightRadius: { xs: "8px", sm: "16px" },
                },
              }}>
              <TableCell sx={headerCellSx}>
                <Typography variant="labelS">Firm Name</Typography>
              </TableCell>
              {showGstPan && (
                <TableCell sx={headerCellSx}>
                  <Typography variant="labelS">GST / PAN</Typography>
                </TableCell>
              )}
              <TableCell sx={headerCellSx}>
                <Typography variant="labelS">Mobile Number</Typography>
              </TableCell>
              <TableCell sx={headerCellSx}>
                <Typography variant="labelS">Role</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: "#FFF" }}>
            {rows.map((row, index) => (
              <TableRow
                key={row?.id ?? index}
                onClick={() => {
                  setSelectedRow(row);
                  onRowClick(row);
                }}
                sx={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedRow?.id === row.id ? "#995A000D" : "transparent",
                  transition: "all 0.2s ease-in-out",
                  boxShadow:
                    selectedRow?.id === row.id
                      ? "inset 0px 0px 0px 1px #995A00"
                      : "inset 0px 0px 0px 1px #0000",

                  "&:hover": {
                    boxShadow: "inset 0px 0px 0px 1px #995A00",
                    backgroundColor:
                      selectedRow?.id === row.id ? "#995A000D" : "#F49D3F0D",
                  },
                }}>
                <TableCell sx={{ ...bodyCellSx, maxWidth: 200 }}>
                  <Typography variant="p3" noWrap>
                    {row?.name || "-"}
                  </Typography>
                </TableCell>
                {showGstPan && (
                  <TableCell sx={bodyCellSx}>
                    <Typography variant="p3">
                      {row?.gstin_pan || "-"}
                    </Typography>
                  </TableCell>
                )}
                <TableCell sx={bodyCellSx}>
                  <Typography variant="p3">{row?.phone_no || "-"}</Typography>
                </TableCell>
                <TableCell sx={bodyCellSx}>
                  <Typography variant="p3">
                    {row?.role_details?.display_name || "-"}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SearchResultTable;
